// Minimal error boundary fallback shown when a route or subtree fails to render.
import { useT } from '@/i18n/useT';

const ErrorFallback = () => {
  const t = useT();
  return <p>{t('error.occurred', 'An error has occurred')}</p>;
};

export default ErrorFallback;
